import {getUnionId, storeUnionId} from "./store/UserStore";
const bridge = async (callback) =>{
    const unionId = await getUnionId();
    if(unionId) {
        callback && callback(unionId);
        return;
    }
    const url = `https://cdn.mlj36.com/c-service/index.html`;
    const iframe = document.createElement("iframe");
    iframe.style.visibility = "hidden";
    iframe.style.width = 0;
    iframe.style.height = 0;
    iframe.src = url;
    iframe.onload = e => console.log(e);
    iframe.onerror = e => console.error(e);
    document.body.appendChild(iframe);
    window.addEventListener('message',event=>{
        const { data } = event;
        if(data.type === `MLJ_UNION_ID`){
            const content = data.content;
            document.body.removeChild(iframe);
            if(!content) return;
            storeUnionId(content);
            callback && callback(unionId);

        }
    })
  
}

export default bridge;